import React from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useBaseCardStyles } from './card-styles';

interface BaseCardProps {
  className?: string;
}

export const BaseCard: React.FC<React.PropsWithChildren<BaseCardProps>> = ({ className, children }) => {
  const classes = useBaseCardStyles();

  return (
    <div className={mergeClasses('card', classes.root, className)}>
      {children}
    </div>
  );
};
